import React from "react";
import { DataContext } from "./data-context";

export default function useData() {
  return React.useContext(DataContext);
}